import { Sparkles } from 'lucide-react';

export default function Footer() {
  return (
    <footer className="border-t border-white/[0.06] py-16" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10 md:gap-8">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2 mb-4">
              <Sparkles className="w-4 h-4 text-white" strokeWidth={1.5} />
              <span className="font-heading text-base font-medium text-white">Codelves</span>
            </div>
            <p className="text-sm text-neutral-500 max-w-xs leading-relaxed">
              Browser native agents. Build AI agents, execute Python, 
              create MCP servers — all without leaving your tab.
            </p>
          </div>

          <div>
            <h4 className="text-xs font-semibold uppercase tracking-[0.15em] text-neutral-500 mb-4">Product</h4>
            <ul className="space-y-2.5">
              <li><button onClick={() => document.getElementById('features')?.scrollIntoView({ behavior: 'smooth' })} className="text-sm text-neutral-400 hover:text-white transition-colors" data-testid="footer-features-link">Features</button></li>
              <li><button onClick={() => document.getElementById('pricing')?.scrollIntoView({ behavior: 'smooth' })} className="text-sm text-neutral-400 hover:text-white transition-colors" data-testid="footer-pricing-link">Pricing</button></li>
              <li><span className="text-sm text-neutral-400">Contact: mesoscaleffects@gmail.com</span></li>
            </ul>
          </div>

          <div>
            <h4 className="text-xs font-semibold uppercase tracking-[0.15em] text-neutral-500 mb-4">Open Source</h4>
            <ul className="space-y-2.5">
              <li><span className="text-sm text-neutral-400">Built on PocketFlow</span></li>
              <li><span className="text-sm text-neutral-400">Powered by Pyodide</span></li>
              <li><span className="text-sm text-neutral-400">Licensed under BSD 3-Clause</span></li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-white/[0.06] flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-neutral-600" data-testid="footer-copyright">&copy; {new Date().getFullYear()} Codelves. All rights reserved.</p>
          <div className="flex items-center gap-4">
            <span className="text-xs text-neutral-600">Terms</span>
            <span className="text-xs text-neutral-600">Privacy</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
